import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import HomeView from "../views/home/homeView.vue";
import { nextTick } from "vue";
import AOS from "aos";
import i18n from "../locals/index"; // ⚠️ 引入 i18n 实例

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { titleKey: "header.home" },
  },
  {
    path: "/products/:name",
    name: "products",
    component: () => import("../views/products/products.vue"),
    meta: { titleKey: "header.products" },
  },
  {
    path: "/solution/:name",
    name: "solution",
    component: () => import("../views/solution/solution.vue"),
    meta: { titleKey: "header.solution" },
  },
  {
    path: "/integration",
    name: "integration",
    component: () => import("../views/integration/integration.vue"),
    meta: { titleKey: "header.integrate" },
  },
  {
    path: "/plan",
    name: "plan",
    component: () => import("../views/plan/plan.vue"),
    meta: { titleKey: "header.plan" },
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact/contact.vue"),
    meta: { titleKey: "header.contact" },
  },
  {
    path: "/manual",
    name: "manual",
    component: () => import("../views/manual/manual.vue"),
    meta: { title: "Manual" },
  },
  {
    path: "/agreement",
    name: "zc",
    component: () => import("../views/manual/agreement.vue"),
    meta: { title: "Service Agreement" },
  },
  {
    path: "/policy",
    name: "ys",
    component: () => import("../views/manual/policy.vue"),
    meta: { title: "Privacy Policy" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
});

// 动态标题（支持语言切换）
router.beforeEach((to, from, next) => {
  const { t } = i18n.global;

  if (to.meta.titleKey) {
    document.title = t(to.meta.titleKey);
  } else {
    document.title = to.meta.title || "官网";
  }

  next();
});

router.afterEach(() => {
  window.scrollTo(0, 0);
  nextTick(() => {
    setTimeout(() => {
      AOS.refreshHard();
    }, 50);
  });
});

export default router;
